import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';
import DetalleAnexo from './Anexo/DetalleAnexo';



const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class AnexoModal extends React.Component {
    render() {


        return (
            <Modal
                title={"Detalle de Anexo"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1200}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cerrar
                    </Button>,
                    <Button
                      key="ok"
                      type="success"
                       //loading={this.props.saveLoading}
                      onClick={() => this.props.onExportExcel(this.props.formValues.id)}  

                    >
                      Exportar Excel
                    </Button>,
                    
                ]}
            >
                <Form>

                    
                <div className="row">
                        <div className="col-md-4">
                            <Form.Item label="Nro Planilla">
                            <Input disabled={true}
                                    value={this.props.formValues.serie +"-"+this.props.formValues.correlativo} 
                                />
                            </Form.Item>
                        </div>
                  

                        <div className="col-md-3">
                            <Form.Item label="Fecha y hora de apertura">
                                <Input disabled={true}
                                    value={this.props.formValues.fechaApertura}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-2" hidden={true}>
                            <Form.Item label="Tipo de cambio">
                                <Input disabled={true}
                                    value={this.props.formValues.TipoCambio}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-3">
                            <Form.Item label="Fecha y hora de cierre">
                                <Input disabled={true}
                                    value={this.props.formValues.fechaCierre}
                                />
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
              
                        <div className="col-md-3">
                            <Form.Item label="Establecimiento">
                                <InputGroup compact>
                                    <Input disabled={true}
                                        value={this.props.formValues.establecimiento}
                                    />
                                   
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4">
                            <Form.Item label="Caja">
                            <Input disabled={true}
                                    value={this.props.formValues.caja}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-md-5">
                            <Form.Item label="Responsable de manejo de caja">
                                <Input disabled={true}
                                    value={this.props.formValues.empleado}
                                />
                            </Form.Item>
                        </div>
                    </div>
        
             
                    <div className="row">
                        <div className="col-md-12 form-group">
                             <Tabs>
                                <TabPane tab="Detalle de anexos" key="1">
                                    <DetalleAnexo
                                        pagination={this.props.pagination}
                                        onChange={this.props.onChangePago}

                                    />
                                </TabPane>
                        </Tabs>  
                        </div>

                   
                    </div>
               
                </Form>
            </Modal>
        );
    }
}